export default __webpack_public_path__ + "static/media/screen5.73ca728c.jpg";